import {
	Button,
	Loading,
	SearchSelectOptionProps,
} from "@alm/flow-ds/components";
import axios from "axios";
import { createAlertAction } from "data/app/appActions";
import api from "lib/api";
import { createErrorAlert } from "lib/api/errors";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import store from "store";
import { RolesForm, RoleName, RoleDescription, MembersPanel } from "..";

export default () => {
	const { t } = useTranslation();
	const history = useHistory();

	const [alert, setAlert] = useState<string | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(false);

	// State for form inputs
	const [members, setMembers] = useState<SearchSelectOptionProps[]>([]);
	const [managers, setManagers] = useState<SearchSelectOptionProps[]>([]);
	const [name, setName] = useState<string>("");
	const [description, setDescription] = useState<string | undefined>(
		undefined
	);

	// Creating a brand new role
	const handleCreateRole = useCallback(async () => {
		setLoading(true);
		const trimName = name.trim();
		const trimDesc = description?.trim();
		// If name of role is not defined then show alert
		if (!trimName) {
			setAlert("missingRoleName");
		} else {
			try {
				await api.roles.addRole(
					{
						name: trimName,
						description: trimDesc
							? trimDesc
							: t("main.admin.text.noDescription"),
						users: members?.map(member => {
							return member.value;
						}),
						managers: managers?.map(manager => {
							return manager.value;
						}),
					},
					{ handleErrors: true }
				);
				history.push("/admin/roles");
			} catch (error) {
				console.error(error);
				if (error && axios.isAxiosError(error))
					store.dispatch(
						createAlertAction(
							createErrorAlert(error, "errorCreatingRole")
						)
					);
				setLoading(false);
			}
		}
	}, [description, history, managers, members, name, t]);

	return (
		<RolesForm alert={alert} setAlert={setAlert}>
			<RoleName
				name={name}
				setName={setName}
				alert={alert === "missingRoleName"}
			/>
			<RoleDescription
				description={description}
				setDescription={setDescription}
			/>
			<MembersPanel
				members={members}
				setMembers={setMembers}
				type="members"
			/>
			<MembersPanel
				members={managers}
				setMembers={setManagers}
				type="managers"
			/>
			<div className="admin__role-form__create">
				<Button
					className="btn-primary"
					label={!loading && t("main.admin.labels.createRole")}
					onClick={handleCreateRole}>
					{loading && <Loading />}
				</Button>
			</div>
		</RolesForm>
	);
};
